import {PromotionListPage as NewPromotionListPage} from '@/features/PromotionList/PromotionListPage.jsx'
import {PromotionsListPage} from '@/pages'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {NEW_THEME_FEATURE_COUNTRIES} from '@/utils/constants/marketFeatureCountries'
import {useSelector} from 'react-redux'

const PromotionListByMarket = () => {
  const countryCode = useSelector(selectCountryCode)

  if (NEW_THEME_FEATURE_COUNTRIES.includes(countryCode)) {
    return <NewPromotionListPage />
  }

  return <PromotionsListPage />
}

export default PromotionListByMarket
